<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h1>7 Keajaiban Dunia Yang Baru</h1>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            &emsp;7 keajaiban dunia  adalah simbol dari warisan dunia dan saksi tingginya arus turis dari berbagai belahan dunia. 7 keajaiban yang baru ini telah menghasilkan lebih dari 100 juta vote pada tahun 2007 oleh sebuah organisasi yang bernama 7 Wonders Foundation yang secara resmi telah merilis new 7 wonders of the world.
          </p>

          <h5 class="mt-3">1. Colosseum, Italia</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/fatih-ozdemir-3TYYiHRTKcg.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@fatihozdemir</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Bangunan tempat pertarungan gladiator dan binatang pada abad 80 masehi ini memiliki lebih dari 80 pintu masuk, dan tempat duduk untuk sekitar 50.000 orang. Bangunan ini mempunyai amfiteater yang konon sering digunakan untuk menyelenggarakan gim gladiator dalam skala besar. Saat ini beberapa bagian Colosseum telah hancur karna gempa bumi, penjarah, pengacau ataupun kebakaran. Namun masoih tetap memiliki pemandangan yang indah.
          </p>

          <h5 class="mt-3">2. Chichén Itzá, Meksiko</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/christina-warner-JELUPXqdKDw.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@legalloriginal</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Sisa dari peninggalan bangsa Maya yang terletak di Semenanjung Yucatán ini telah masuk ke dalam daftar situs warisan dunia UNESCO setelah ditemukan pada 1841. Chichen Itza jika di artikan berarti “di bibir mata rakyat” dan diyakini merujuk pada Semenanjung Yucatan yang terkenal dengan sungai bawah lautnya, dan lubang pembuangan air tawar terbuka yang disebut ‘cenote’.
          </p>

          <h5 class="mt-3">3. Taj Mahal, India</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/jovyn-chamb-iWMfiInivp4.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@jovynchamb</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Bangunan berbahan dasar marmer putih ini merupakan simbol cinta seorang Kaisar Mughal Shah Jahan kepada mendiang sang istri, Mumtaz Mahal, yang kala itu melahirkan 14 anak namun meninggal saat melahirkannya. Kemudian Jahan yang kehilangan istri tersayangnya memerintahkan sekitar 20.000 pekerja dan 1.000 gajah untuk membangun Taj Mahal pada tahun 1631 dan selesai pada tahun 1684.
          </p>

          <h5 class="mt-3">4. Patung Kristus Penebus, Brazil</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/ckturistando-RSvKa3Jg3Z8.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@ckturistando</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Patung kristus ikonik ini berada di Rio de Janeiro, Brazil dan selesai dibangun pada tahun 1931. Patung ini menjulang sepanjang 98 kaki dengan tangan terentang. Dianggap sebagai monumen buatan manusia terindah di dunia, dan simbol kedamaian serta sambutan.
          </p>

          <h5 class="mt-3">5. The Great Wall Of China, China</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/hanson-lu-Q36BvLGdOAg.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@hansonluu</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Fungsi dari bangunan ini di awal adalah untuk menghalau penyerbu ke utara keluar dari China. Membentang sepanjang 8.825 km, UNESCO menyatakan kalau bangunan ini merupakan contoh luar biasa dari gabungan arsitektur, teknologi, dan seni China kuno. Tembok Besar China adalah satu-satunya struktur buatan manusia yang bisa terlihat dari luar angkasa.
          </p>

          <h5 class="mt-3">6. Petra, Jordania</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/brian-kairuz-5JHj33-s604.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@bmk001</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Terletak di daerah gurun barat daya Jordania, antara Laut Mati dan Laut Merah, Petra merupakan bekas pemukiman zaman pra-sejarah. Lokasi syuting dari film “Indiana Jones And The Last Crusade” (1989) ini dikenal sebagai perhentian kafilah yang mengembara antara Mediterania dan Tiur pada masa Yunani dan Roma kuno.
          </p>

          <h5 class="mt-3">7. Machu Picchu, Peru</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/willian-justen-de-vasconcellos-4hMET7vYTAQ.jpg')"
              fluid
              class="content-picture"
              style="max-width: 60%;"
            />
            <br>
            <i style="font-size:14px; color: #7f7f7f;">https://unsplash.com/@willianjusten</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Machu Picchu adalah salah satu situs paling mengesankan di dunia ini, di bangun 7.000 kaki di atas permukaan laut dan dianggap sebagai destinasi yang paling sulit di jangkau dari seluruh destinasi dalam daftar ini. Machu Picchu merupakan benteng kuno yang dibangun suku Inca pada abad ke-15, namun pembangunannya tidak selesai akibat invasi Spanyol pada abad ke-16. Diperkirakan hanya sekitar 750 orang yang tinggal disini karna merupakan kerajaan dan bukan kota yang layak untuk ditinggali. Dalam bahasa asli, Quechua, namanya berarti puncak tua.
          </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12">
          <h4>7 Keajaiban Dunia Yang Baru</h4>
        </b-col>

        <b-col>
          <p class="mt-3 text-justify">
            &emsp;7 keajaiban dunia  adalah simbol dari warisan dunia dan saksi tingginya arus turis dari berbagai belahan dunia. 7 keajaiban yang baru ini telah menghasilkan lebih dari 100 juta vote pada tahun 2007 oleh sebuah organisasi yang bernama 7 Wonders Foundation yang secara resmi telah merilis new 7 wonders of the world.
          </p>

          <h5 class="mt-3">1. Colosseum, Italia</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/fatih-ozdemir-3TYYiHRTKcg.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@fatihozdemir</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Bangunan tempat pertarungan gladiator dan binatang pada abad 80 masehi ini memiliki lebih dari 80 pintu masuk, dan tempat duduk untuk sekitar 50.000 orang. Bangunan ini mempunyai amfiteater yang konon sering digunakan untuk menyelenggarakan gim gladiator dalam skala besar. Saat ini beberapa bagian Colosseum telah hancur karna gempa bumi, penjarah, pengacau ataupun kebakaran. Namun masoih tetap memiliki pemandangan yang indah.
          </p>

          <h5 class="mt-3">2. Chichén Itzá, Meksiko</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/christina-warner-JELUPXqdKDw.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@legalloriginal</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Sisa dari peninggalan bangsa Maya yang terletak di Semenanjung Yucatán ini telah masuk ke dalam daftar situs warisan dunia UNESCO setelah ditemukan pada 1841. Chichen Itza jika di artikan berarti “di bibir mata rakyat” dan diyakini merujuk pada Semenanjung Yucatan yang terkenal dengan sungai bawah lautnya, dan lubang pembuangan air tawar terbuka yang disebut ‘cenote’.
          </p>

          <h5 class="mt-3">3. Taj Mahal, India</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/jovyn-chamb-iWMfiInivp4.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@jovynchamb</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Bangunan berbahan dasar marmer putih ini merupakan simbol cinta seorang Kaisar Mughal Shah Jahan kepada mendiang sang istri, Mumtaz Mahal, yang kala itu melahirkan 14 anak namun meninggal saat melahirkannya. Kemudian Jahan yang kehilangan istri tersayangnya memerintahkan sekitar 20.000 pekerja dan 1.000 gajah untuk membangun Taj Mahal pada tahun 1631 dan selesai pada tahun 1684.
          </p>

          <h5 class="mt-3">4. Patung Kristus Penebus, Brazil</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/ckturistando-RSvKa3Jg3Z8.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@ckturistando</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Patung kristus ikonik ini berada di Rio de Janeiro, Brazil dan selesai dibangun pada tahun 1931. Patung ini menjulang sepanjang 98 kaki dengan tangan terentang. Dianggap sebagai monumen buatan manusia terindah di dunia, dan simbol kedamaian serta sambutan.
          </p>

          <h5 class="mt-3">5. The Great Wall Of China, China</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/hanson-lu-Q36BvLGdOAg.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@hansonluu</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Fungsi dari bangunan ini di awal adalah untuk menghalau penyerbu ke utara keluar dari China. Membentang sepanjang 8.825 km, UNESCO menyatakan kalau bangunan ini merupakan contoh luar biasa dari gabungan arsitektur, teknologi, dan seni China kuno. Tembok Besar China adalah satu-satunya struktur buatan manusia yang bisa terlihat dari luar angkasa.
          </p>

          <h5 class="mt-3">6. Petra, Jordania</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/brian-kairuz-5JHj33-s604.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@bmk001</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Terletak di daerah gurun barat daya Jordania, antara Laut Mati dan Laut Merah, Petra merupakan bekas pemukiman zaman pra-sejarah. Lokasi syuting dari film “Indiana Jones And The Last Crusade” (1989) ini dikenal sebagai perhentian kafilah yang mengembara antara Mediterania dan Tiur pada masa Yunani dan Roma kuno.
          </p>

          <h5 class="mt-3">7. Machu Picchu, Peru</h5>
          <div class="text-center">
            <b-img
              :src="require('@/assets/img/articles/1911261/willian-justen-de-vasconcellos-4hMET7vYTAQ.jpg')"
              fluid
              class="content-picture"
              style="max-width: 80%;"
            />
            <br>
            <i style="font-size: 11px; color: #7f7f7f;">https://unsplash.com/@willianjusten</i>
          </div>
          <p class="mt-3 text-justify">
            &emsp;Machu Picchu adalah salah satu situs paling mengesankan di dunia ini, di bangun 7.000 kaki di atas permukaan laut dan dianggap sebagai destinasi yang paling sulit di jangkau dari seluruh destinasi dalam daftar ini. Machu Picchu merupakan benteng kuno yang dibangun suku Inca pada abad ke-15, namun pembangunannya tidak selesai akibat invasi Spanyol pada abad ke-16. Diperkirakan hanya sekitar 750 orang yang tinggal disini karna merupakan kerajaan dan bukan kota yang layak untuk ditinggali. Dalam bahasa asli, Quechua, namanya berarti puncak tua.
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191126-7-keajaiban-dunia',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px -5px rgba(0, 0, 0, 0.5);
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191126-7-keajaiban-dunia.vue